<script lang="ts">
  import { Activity } from '@/Common/ActivityFunctions';
  import TodayTimelineCard from './TodayTimelineCard.svelte';
  import { getContext } from 'svelte';
  import type { MyFitnessStores } from '../stores';
  import type { TodaysActivities } from '@/Common/constants';

  export let todaysActivities: TodaysActivities;
  export let activityImageCarouselNumber: Record<string, number>;
  export let conflictNotes: string[] = [];
  
  const { trainingPlan } = getContext<MyFitnessStores>('myFitness');

  $: activities = todaysActivities.activities.filter(a => !(Activity.isPlanned({ ...a, activity_mode: a.activity_mode}) && (!Activity.isForecast({ ...a, state: a.state }) || !$trainingPlan.isForecastPlan) && Activity.hasMatch(a)));
  function buildTimelineEntries(activities) {
    const items: any[] = activities.slice().sort((a, b) => new Date(a.start_date).getTime() - new Date(b.start_date).getTime());

    const entries: Array<{ kind: 'hour'; hour: string } | { kind: 'activity'; a: any }> = [];
    let lastHour: string | null = null;
    for (const a of items) {
      // TODO (hyde): should this sometimes be 24 hour time based on user preference?
      const d = new Date(a.start_date);
      d.setMinutes(0, 0, 0);
      const h = (new Intl.DateTimeFormat('en', { hour: '2-digit', minute: '2-digit', hour12: true })).format(d);
      if (h !== lastHour) {
        entries.push({ kind: 'hour', hour: h });
        lastHour = h;
      }
      entries.push({ kind: 'activity', a });
    }
    return entries;
  }

</script>

<section class="mt-2">
  {#if activities.length > 0}
    <div class="relative">
      <div class="absolute left-2 md:left-6 top-0 h-full w-px bg-gray-200"></div>
      <div class="space-y-2">
        {#each buildTimelineEntries(activities) as entry (entry.kind === 'activity' ? entry.a.path : entry.hour)}
          {#if entry.kind === 'hour'}
            <div class="z-10 -mx-2 bg-gray-50/70 px-2 py-1 text-xs font-medium text-gray-600 backdrop-blur">{entry.hour}</div>
          {:else}
            {#if !Activity.isDuplicate(entry.a) || Activity.getDuplicateGroupHead(entry.a, activities) === null}
              <TodayTimelineCard {todaysActivities} activity={entry.a} bind:activityImageCarouselNumber conflictNotes={Activity.isForecast(entry.a) ? conflictNotes : []} />
            {/if}
          {/if}
        {/each}
      </div>
    </div>
  {:else}
    <div class="text-sm text-gray-500 mt-[20px] md-[8px]">No planned or completed activities today.</div>
  {/if}
</section>
